import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { style: {"margin":"1em 0"} }
const _hoisted_2 = { class: "images" }

import MediaForm from '@/components/media/MediaForm.vue';
import MediaItem from '@/components/media/MediaItem.vue';
import { Media, MediaPurpose } from '@/models/media.model';
import { Event, useEvents } from '@/services/events.composable';
import { Mutations, ShiftCMSState } from '@/store';
import { markRaw, PropType, onUnmounted, ref } from 'vue';
import { useStore } from 'vuex';


export default /*@__PURE__*/_defineComponent({
  __name: 'MediaList',
  props: {
  modelValue: {
    type: Object as PropType<{ media: Media[] }>,
    required: true,
  },
  required: {
    type: Array as PropType<MediaPurpose[]>,
    default: () => [],
  },
  top: {
    type: Boolean,
    default: () => false,
  },
  disabled: {
    type: Boolean,
    default: () => false,
  },
},
  emits: ['update:modelValue', 'change'],
  setup(__props, { emit: __emit }) {

const store = useStore<ShiftCMSState>();

const props = __props;

const requiresSave = ref<boolean>(false);

const events = useEvents();
const emit = __emit;

const useMedia = (m: Media) => {
  emit('update:modelValue', {
    ...props.modelValue,
    media: [...(props.modelValue.media || []), m],
  });

  requiresSave.value = true;

  emit('change');

  events.off(Event.UseMedia, useMedia);
  store.commit(props.top ? Mutations.HideDrawer : Mutations.HideSubDrawer);
};

const updateMedia = (m: Media) => {
  emit('update:modelValue', {
    ...props.modelValue,
    media: [
      ...(props.modelValue.media || []).filter((me) => me.id !== m.id),
      m,
    ],
  });

  requiresSave.value = true;

  emit('change');

  events.off(Event.UpdateMedia, useMedia);
  store.commit(props.top ? Mutations.HideDrawer : Mutations.HideSubDrawer);
};

const removeMedia = (m: Media) => {
  emit('update:modelValue', {
    ...props.modelValue,
    media: [...(props.modelValue.media || []).filter((me) => me.id !== m.id)],
  });

  requiresSave.value = true;
  emit('change');
};

const viewMedia = (m: Media) => {
  window.open(`/file/${m.file?.uuid}/large.webp`, 'new');
};

const updateSaved = () => (requiresSave.value = false);

const editMedia = (m?: Media) => {
  events.on(Event.Saved, updateSaved);
  events.on(Event.UseMedia, useMedia);
  events.on(Event.UpdateMedia, updateMedia);
  store.commit(props.top ? Mutations.ShowDrawer : Mutations.ShowSubDrawer, {
    component: markRaw(MediaForm),
    data: { media: m },
  });
};

onUnmounted(() => {
  events.off(Event.Saved, updateSaved);
  events.off(Event.UseMedia, useMedia);
  events.off(Event.UpdateMedia, updateMedia);
});

return (_ctx: any,_cache: any) => {
  const _component_v_alert = _resolveComponent("v-alert")!
  const _component_v_btn = _resolveComponent("v-btn")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h3", null, _toDisplayString(_ctx.$t('initiative.edit.media')), 1),
    (
        props.required.filter(
          (v) => !props.modelValue.media?.map((m) => m.purpose).includes(v),
        ).length
      )
      ? (_openBlock(), _createBlock(_component_v_alert, {
          key: 0,
          density: "compact",
          type: "warning",
          class: "mb-4 mt-4"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('initiative.edit.mediaRequired', {
          list: props.required
            .filter(
              (v) => !props.modelValue.media?.map((m) => m.purpose).includes(v),
            )
            .map((v) =>
              _ctx.$t(`initiative.edit.image_${v.replace('-image', '_image')}`),
            )
            .join(', '),
        })), 1)
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (props.modelValue.media?.length === 0)
      ? (_openBlock(), _createBlock(_component_v_alert, {
          key: 1,
          density: "compact",
          type: "info",
          class: "mb-4 mt-4"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('initiative.edit.mediaNone')), 1)
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (requiresSave.value)
      ? (_openBlock(), _createBlock(_component_v_alert, {
          key: 2,
          density: "compact",
          type: "info",
          class: "mb-4 mt-4"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('initiative.edit.mediaSave')), 1)
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.modelValue.media, (m) => {
        return (_openBlock(), _createBlock(MediaItem, {
          media: m,
          key: m.id,
          "show-options": ['edit', 'remove'],
          showInfo: true,
          disabled: __props.disabled,
          onEdit: ($event: any) => (editMedia(m)),
          onRemove: ($event: any) => (removeMedia(m)),
          onView: ($event: any) => (viewMedia(m))
        }, null, 8, ["media", "disabled", "onEdit", "onRemove", "onView"]))
      }), 128))
    ]),
    (!__props.disabled)
      ? (_openBlock(), _createBlock(_component_v_btn, {
          key: 3,
          onClick: _cache[0] || (_cache[0] = ($event: any) => (editMedia()))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('initiative.edit.mediaEdit')), 1)
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ]))
}
}

})